export interface FakeProduct {
  name: string,
  external_id: string,
  price: number,
}

export const FakeProducts: FakeProduct[] = [
  {
    name: 'ING',
    external_id: 'ING',
    price: 1339.2
  },
  {
    name: 'Aegon',
    external_id: 'AEG',
    price: 1249.2
  },
  {
    name: 'Allianz',
    external_id: 'ALL',
    price: 1349.2
  },
]

export const AlternativeProducts: FakeProduct[] = [
  {
    name: 'ABN Amro',
    external_id: 'ABN',
    price: 1139.2
  },
  {
    name: 'Argenta',
    external_id: 'ARG',
    price: 1249.2
  },
  {
    name: 'Attens Hypotheken',
    external_id: 'ATS',
    price: 1449.0
  },
  {
    name: 'bijBouwe',
    external_id: 'bBo',
    price: 950.0
  },
]
